import { api } from "../services/index";

export function getGroups(query) {
  if (query?.missingPolicies) return api.get(`/groups?missingPolicies=true`);
  return api.get(`/groups`);
}

export function getGroup(groupID, query) {
  if (query?.missingPolicies)
    return api.get(`/groups/${groupID}?missingPolicies=true`);
  return api.get(`/groups/${groupID}`);
}

export function getGroupRoles(groupID) {
  return api.get(`/groups/${groupID}/roles`);
}

export function getGroupUsers(groupID) {
  return api.get(`/groups/${groupID}/users`);
}

export function editGroup(groupID, data) {
  return api.patch(`/groups/${groupID}`, data);
}

export function addGroup(data) {
  return api.put(`/groups`, data);
}

export function addGroupRole(groupID, data) {
  return api.post(`/groups/${groupID}/roles/batch-add`, data);
}

export function addGroupUser(groupID, data) {
  return api.post(`/groups/${groupID}/users/batch-add`, data);
}

export function deleteGroupRole(groupID, data) {
  return api.post(`/groups/${groupID}/roles/batch-delete`, data);
}

export function deleteGroupUser(groupID, data) {
  return api.post(`/groups/${groupID}/users/batch-delete`, data);
}

export function deleteGroup(groupID) {
  return api.delete(`/groups/${groupID}`);
}

export function duplicateGroup(groupID, data) {
  return api.post(`/groups/${groupID}`, data);
}
